import { priceTemplate } from '@/lib/cms/template-data'

export const MEDICAL_CERTIFICATE_SERVICES = [
  {
    type: 'Medical Certificate',
    category: 'Single-Day',
    price: priceTemplate('medicalCertificateSingleDay'),
    link: '/request-certificate/medical',
  },
  {
    type: 'Medical Certificate',
    category: 'Two-Day',
    price: priceTemplate('medicalCertificateMultiDay'),
    link: '/request-certificate/medical-multiple-days',
  },
  {
    type: 'Carer Certificate',
    category: 'Single-Day',
    price: priceTemplate('medicalCertificateSingleDay'),
    link: '/request-certificate/carer',
  },
  {
    type: 'Carer Certificate',
    category: 'Two-Day',
    price: priceTemplate('medicalCertificateMultiDay'),
    link: '/request-certificate/carer-multiple-days',
  },
]

export const ALL_SERVICES_AD = [
  {
    title: 'Medical Certificates',
    link: '/medical-certificates-online',
  },
  {
    title: 'Carer Certificates',
    link: '/carers-certificates-online',
  },
  {
    title: 'Online Prescriptions',
    link: '/prescriptions-online',
  },
  {
    title: 'Specialist Referrals',
    link: '/specialist-referral-online',
  },
  {
    title: 'Telehealth Consultations',
    link: '/telehealth-consultation',
  },
]
